import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';

const PageBackButton = ({ label = 'Back', onClick, sx }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onClick) {
      onClick();
      return;
    }
    navigate(-1);
  };

  return (
    <Button startIcon={<ArrowBack />} onClick={handleBack} sx={sx}>
      {label}
    </Button>
  );
};

export default PageBackButton;
